module.exports = __webpack_public_path__ + "dc2e8df20c9a5e54552bffb5d8f29f74.svg";